<agpr-dialog-container
    id="digestShareDialog"
    [heading]="'Briefings.DigestShareDialog.heading'"
    [modal]="true"
    (close)="closeDialog()"
>
    <agpr-scroll-panel>
        <div class="agpr-digestShareDialog-content">
            <form [formGroup]="form">
                <div
                    class="agpr-digestShareDialog-description"
                    [innerHtml]="'Briefings.DigestShareDialog.description' | localize : { name: digest.name }"
                >
                </div>

                <div class="agpr-digestShareDialog-heading">
                    {{ 'Briefings.DigestShareDialog.sendTo' | localize }}
                </div>

                <div class="agpr-digestShareDialog-inputGroup">
                    <div class="agpr-digestShareDialog-inputLabel">
                        {{ 'Briefings.input.mailingLists' | localize }}
                    </div>
                    <agpr-mailing-list-picker
                        formControlName="mailingListIds"
                    ></agpr-mailing-list-picker>

                    @if (showMailingListError) {
                        <agpr-form-message>
                            {{ 'Briefings.input.mailingLists.validation' | localize }}
                        </agpr-form-message>
                    }
                </div>

                <div class="agpr-digestShareDialog-inputGroup">
                   <agpr-email-chips
                        [value]="recipientListControl?.value"
                        [placeholder]="'Briefings.input.recipients.placeholder' | localize"
                        clearAllChipsTooltip="Briefings.input.recipients.clearAllTooltip"
                        header="Briefings.input.recipients"
                        (valueChange)="onRecipientListChange($event)"
                    ></agpr-email-chips>

                    @if (showRecipientError) {
                        <agpr-form-message>
                            {{ 'Briefings.input.recipients.validation' | localize }}
                        </agpr-form-message>
                    }
                </div>

                <agpr-checkbox
                    label="Briefings.DigestShareDialog.excludeExistingRecipients"
                    [binary]="true"
                    formControlName="excludeExistingRecipients"
                ></agpr-checkbox>

                <div class="agpr-digestShareDialog-heading">
                    {{ 'Briefings.DigestShareDialog.inviteDetails' | localize }}
                </div>

                <div class="agpr-digestShareDialog-inputGroup">
                    <agpr-text-input
                        [id]="'fromTextInput'"
                        [maxLength]="256"
                        [placeholder]="'Briefings.input.fromName.placeholder' | localize"
                        [label]="'Briefings.input.fromName'"
                        formControlName="fromName"
                        [required]="true"
                        [bottomMargin]="false"
                    ></agpr-text-input>
                </div>

                @if (fromNameControl?.touched && fromNameControl?.hasError('required')) {
                    <agpr-form-message class="agpr-briefingError">
                        {{ 'Briefings.input.fromName.validation' | localize }}
                    </agpr-form-message>
                }

                <div class="agpr-digestShareDialog-inputGroup">
                    <agpr-text-input
                        [id]="'replyToTextInput'"
                        [maxLength]="256"
                        [required]="true"
                        [placeholder]="'Briefings.input.replyTo.placeholder' | localize"
                        [label]="'Briefings.input.replyTo'"
                        formControlName="replyTo"
                        [bottomMargin]="false"
                    ></agpr-text-input>
                </div>

                @if (replyToControl?.touched && (replyToControl?.hasError('required') || replyToControl?.hasError('invalidEmail'))) {
                    <ul class="agpr-briefingError">
                        @if (replyToControl?.hasError('required')) {
                            <li>
                                <agpr-form-message>
                                    {{ 'Briefings.input.replyTo.validation' | localize }}
                                </agpr-form-message>
                            </li>
                        } @else if (replyToControl?.hasError('invalidEmail')) {
                            <li>
                                <agpr-form-message>
                                    {{ 'invalidEmailFormat' | localize }}
                                </agpr-form-message>
                            </li>
                        }
                    </ul>
                }

                <div class="agpr-digestShareDialog-inputGroup">
                    <agpr-textarea-input
                        id="inviteMessage"
                        label="Briefings.input.inviteMessage"
                        [maxLength]="2048"
                        [rows]="4"
                        [placeholder]="'Briefings.input.inviteMessage.placeholder' | localize"
                        formControlName="inviteMessage"
                    ></agpr-textarea-input>
                </div>
            </form>
        </div>
    </agpr-scroll-panel>

    <ng-template #footerLeft>
        <agpr-button
            label="Core.button.cancel"
            id="digestShareDialog.cancelButton"
            (click)="closeDialog()"
        ></agpr-button>
    </ng-template>

    <ng-template #footerRight>
        <agpr-button
            id="digestShareDialog.share"
            label="Briefings.DigestShareDialog.share"
            [style]="buttonType.primary"
            (click)="share()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>